import { LayerSpecification } from "@iventis/mapbox-gl";
import { MAPBOX_MAX_ZOOM, MAPBOX_MIN_ZOOM } from "../../../constants";

/** Map background layer types which draw 3D buildings: extruded footprints, landmark models and procedural facades */
export const buildings3dLayerTypes: LayerSpecification["type"][] = ["fill-extrusion", "model", "building"];

/** Accepts the wider type returned by `map.getLayer`, which can also be a custom layer */
export const isBuildings3dLayerType = (type: LayerSpecification["type"] | "custom") => buildings3dLayerTypes.includes(type as LayerSpecification["type"]);

export const updateLayerDynamicStyling = (layer: LayerSpecification, buildings3d: boolean, streetNames: boolean): LayerSpecification => {
    // Clone the layer to avoid mutating the original cached layer spec
    const clonedLayer = JSON.parse(JSON.stringify(layer)) as LayerSpecification;

    // Check the 3D building layers first and disable if 3dbuildings is off
    if (buildings3d === false && isBuildings3dLayerType(clonedLayer.type)) {
        clonedLayer.layout = { ...clonedLayer.layout, visibility: "none" };
    }

    // Hide or show 2d areas in their place
    if (buildings3d === false && clonedLayer.type === "fill") {
        clonedLayer.maxzoom = MAPBOX_MAX_ZOOM;
        clonedLayer.minzoom = clonedLayer?.minzoom ?? MAPBOX_MIN_ZOOM;
    }

    if (streetNames === false && clonedLayer.type === "symbol") {
        clonedLayer.layout = { ...clonedLayer.layout, visibility: "none" };
    }
    return clonedLayer;
};
